import { faCircleInfo } from "@jewlr/pro-regular-svg-icons/faCircleInfo"

import FontAwesomeIcon from "components/ui/font-awesome-icon"

const CustomerSupportNotice = () => (
  <div className="contained-wide tablet:px-32 widescreen:px-60 mb-32 px-16">
    <section
      aria-labelledby="footer-customer-support-update"
      className="tablet:gap-16 tablet:p-24 flex items-start gap-12 rounded-lg border border-white/30 bg-white/10 p-16 text-white"
    >
      <FontAwesomeIcon
        aria-hidden="true"
        className="text-20 mt-4 shrink-0"
        icon={faCircleInfo}
      />
      <div className="text-14 tablet:text-16 leading-relaxed">
        <h2
          className="text-18 tablet:text-20 mb-8 font-semibold"
          id="footer-customer-support-update"
        >
          Customer Support Update
        </h2>
        <p className="mb-8">
          We&apos;re currently making some temporary adjustments to our customer
          support services to better assist our customers.
        </p>
        <p className="mb-8">
          During this time, phone support will be unavailable. However, our team
          is still here to help through <strong>Live Chat</strong> and{" "}
          <strong>email</strong>.
        </p>
        <p>
          We appreciate your patience and understanding and look forward to
          assisting you!
        </p>
      </div>
    </section>
  </div>
)

export default CustomerSupportNotice
